window.clearFinderSelections = function () {
	resetSelections();
	try {
		localStorage.removeItem("journeyStepsValues");
	} catch (e) {}
};
function saveJourneyStepsValues() {
	const obj = {
		type: selectedType,
		machine:
			selectedMachine && selectedMachine.code ? selectedMachine.code : null,
		electrode: selectedElectrode,
		accessories: selectedAccessories,
		treatmentAreas: selectedTreatmentAreas,
	};
	try {
		localStorage.setItem("journeyStepsValues", JSON.stringify(obj));
	} catch (e) {}
}

let modal = null;
let machinesJson = null;
let openBtn = null;
let closeBtn = null;
let steps = [];
let stepperItems = [];
let stickyNavTab = null;
let stickyBackBtn = null;
let stickyNextBtn = null;

function initializeElements() {
	modal = document.getElementById("electrodeModal");
	if (modal) {
		machinesJson = modal.dataset.machines;
	}
	openBtn = document.getElementById("openFinderModal");
	closeBtn = document.getElementById("closeModal");
	steps = Array.from(document.querySelectorAll(".step"));
	stepperItems = document.querySelectorAll(".stepper-item");
	stickyNavTab = document.getElementById("stickyNavTab");
	stickyBackBtn = document.getElementById("stickyBackBtn");
	stickyNextBtn = document.getElementById("stickyNextBtn");
}

let data = null;
let currentStep = 0;

// Обновление URL для хлебных крошек
function updateJourneyUrl(step) {
	const url = window.localeRoot+`/journey/step-${step + 1}`;
	window.history.replaceState({ step }, "", url);
}

let selectedType = null;
let selectedMachine = null;
let selectedElectrode = null;
let selectedAccessories = [];
let selectedTreatmentAreas = [];

const stepMeta = {
	0: {
		title: "1. Choose the correct Electrodes for your TENS machine",
		desc: "Choose the type to narrow down compatible accessories.",
	},
	1: {
		title: "2. Select your device",
		desc: "Pick your TENS machine below. Once you’ve made your choice, we’ll guide you to the right electrodes and accessories for your device.",
	},
	2: {
		title: "3. What are you looking for?",
		desc: "Choose from one or more of our categories. If you’re only looking for electrodes, select the type of electrodes you’re looking for and press ‘next step.",
	},
	3: {
		title: "4. Recommendations",
		desc: 'Check your choices, then press "Show recommendations" to open the dedicated recommendations page.',
	},
};

// Prettify functions for dynamic labels
function prettifyElectrodeKey(key) {
	return key
		.replace(/([A-Z])/g, " $1")
		.replace(/_/g, " ")
		.replace(/(^| )\w/g, (m) => m.toUpperCase())
		.trim();
}

function prettifyAccessoryKey(key) {
	return key
		.replace(/([A-Z])/g, " $1")
		.replace(/_/g, " ")
		.replace(/(^| )\w/g, (m) => m.toUpperCase())
		.trim();
}

function prettifyTreatmentAreaKey(key) {
	return key
		.replace(/([A-Z])/g, " $1")
		.replace(/_/g, " ")
		.replace(/(^| )\w/g, (m) => m.toUpperCase())
		.trim();
}

function loadData() {
	if (data) return;
	try {
		data = JSON.parse(machinesJson);
	} catch (e) {
		console.error("Failed to parse machines JSON:", e);
	}
}

function updateStepper() {
	stepperItems.forEach((item, idx) => {
		item.classList.remove("active", "completed");
		if (idx < currentStep) {
			item.classList.add("completed");
		}
		if (idx === currentStep) {
			item.classList.add("active");
		}
	});
}

function updateStepHeader() {
	const stepDiv = steps[currentStep];
	const titleEl = stepDiv.querySelector(".step-title");
	const descEl = stepDiv.querySelector(".step-desc");

	if (stepMeta[currentStep]) {
		titleEl.textContent = stepMeta[currentStep].title;
		descEl.textContent = stepMeta[currentStep].desc;
	} else {
		titleEl.textContent = "";
		descEl.textContent = "";
	}
}

function updateStickyNav(index) {
	if (!stickyNavTab) return;

	// Show sticky nav from step 2 onwards (index >= 1)
	if (index >= 1) {
		stickyNavTab.style.display = "block";

		// Update button text for the last real step (electrode/accessories/treatment)
		// Step 3 (preview) has been removed from the flow, so "Show recommendations"
		// now appears at index === 2 instead of index === 3.
		if (stickyNextBtn) {
			if (index === 2) {
				stickyNextBtn.innerHTML = `
					Show recommendations
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				`;
			} else {
				stickyNextBtn.innerHTML = `
					Next Step
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				`;
			}
		}
	} else {
		stickyNavTab.style.display = "none";
	}
}

function filterMachineCards() {
	const cards = document.querySelectorAll(".machine-card");
	cards.forEach((card) => {
		if (card.dataset.machineType === selectedType) {
			card.style.display = "";
		} else {
			card.style.display = "none";
		}
	});
}

// Fetch product details from Shopify
async function fetchProductBySKU(sku) {
	try {
		console.log("Searching for product with SKU:", sku);
		const response = await fetch(`/products.json?limit=250`);
		const data = await response.json();

		console.log("Total products found:", data.products.length);

		// Find product by EXACT SKU match only
		for (const product of data.products) {
			for (const variant of product.variants) {
				console.log("Checking variant SKU:", variant.sku, "against:", sku);

				// Only exact match - no partial matching to avoid finding wrong products
				if (variant.sku === sku) {
					console.log("Found exact match!");

					// Clean HTML from description
					let description = '';
					if (product.body_html) {
						const tempDiv = document.createElement('div');
						tempDiv.innerHTML = product.body_html;
						description = tempDiv.textContent || tempDiv.innerText || '';
						description = description.trim().substring(0, 120);
					}

					return {
						title: product.title,
						description: description,
						sku: variant.sku,
						image: product.images && product.images[0] ? product.images[0].src : '',
						price: variant.price,
						handle: product.handle
					};
				}
			}
		}

		console.log("No product found for SKU:", sku);
		return null;
	} catch (error) {
		console.error('Error fetching product:', error);
		return null;
	}
}

// Fetch product details by handle
async function fetchProductByHandle(handle) {
	try {
		console.log("Searching for product with handle:", handle);
		const response = await fetch(`/products/${handle}.js`);
		if (!response.ok) {
			console.log("Product not found by handle:", handle);
			return null;
		}
		const product = await response.json();

		console.log("Found product by handle:", product);

		// Clean HTML from description
		let description = '';
		if (product.description) {
			const tempDiv = document.createElement('div');
			tempDiv.innerHTML = product.description;
			description = tempDiv.textContent || tempDiv.innerText || '';
			description = description.trim().substring(0, 120);
		}

		return {
			title: product.title,
			description: description,
			sku: product.variants && product.variants[0] ? product.variants[0].sku : '',
			image: product.images && product.images[0] ? product.images[0] : product.featured_image,
			price: product.variants && product.variants[0] ? product.variants[0].price : '',
			handle: product.handle
		};
	} catch (error) {
		console.error('Error fetching product by handle:', error);
		return null;
	}
}

async function displaySelectedMachine() {
	const currentStepDiv = steps[currentStep];
	if (!currentStepDiv) return;

	const machineDisplay = currentStepDiv.querySelector(".selected-machine-display");
	if (!machineDisplay) return;

	if (selectedMachine) {
		console.log("displaySelectedMachine - selectedMachine:", selectedMachine);

		const cardContainer = machineDisplay.querySelector(".selected-machine-card");
		const skeletonContainer = machineDisplay.querySelector(".selected-machine-skeleton");

		// Show skeleton, hide card
		if (skeletonContainer) skeletonContainer.style.display = "flex";
		if (cardContainer) cardContainer.style.display = "none";
		machineDisplay.style.display = "block";

		// Fetch product details from Shopify
		// If machine has handle, use it; otherwise use SKU
		let productData = null;
		if (selectedMachine.handle) {
			console.log("Using handle for search:", selectedMachine.handle);
			productData = await fetchProductByHandle(selectedMachine.handle);
		} else {
			console.log("Using SKU for search:", selectedMachine.code);
			productData = await fetchProductBySKU(selectedMachine.code);
		}

		console.log("Fetched product data:", productData);

		// Hide skeleton, show card
		if (skeletonContainer) skeletonContainer.style.display = "none";
		if (cardContainer) {
			cardContainer.style.display = "block";
			cardContainer.innerHTML = '';
			const card = document.createElement("div");
			card.className = "custom-product-option-wrapper";

			// Use Shopify product data if available, otherwise fall back to JSON data
			const description = productData ? productData.description : (selectedMachine.description || '');
			const sku = productData ? productData.sku : (selectedMachine.code || '');
			const image = productData ? productData.image : selectedMachine.photoUrl;
			const name = productData ? productData.title : selectedMachine.machineName;

			console.log("Using description:", description);
			console.log("Using sku:", sku);

			card.innerHTML = `
				<div>
					<img class="custom-radio-option-image" src="${image}" alt="${name}">
					<div class="custom-radio-option-info">
						<span class="custom-radio-option-name">${name}</span>
						${description ? `<span class="custom-radio-option-description">${description}</span>` : ''}
						${sku ? `<span class="custom-radio-option-sku">SKU: ${sku}</span>` : ''}
					</div>
				</div>
			`;
			cardContainer.appendChild(card);
		}
	} else {
		machineDisplay.style.display = "none";
	}
}

function showStep(index) {
	steps.forEach((s, i) => {
		s.style.opacity = 0;
		if (i === index) {
			s.style.display = "block";
			setTimeout(() => {
				s.style.opacity = 1;
			}, 50);
		} else {
			s.style.display = "none";
		}
	});

	if (index === 2) {
		buildStepContent();
	}

	// Display selected machine on steps after machine selection
	if (index >= 2) {
		displaySelectedMachine();
	}

	updateStepper();
	updateStepHeader();
	updateJourneyUrl(index);
	updateStickyNav(index);

	try {
		localStorage.setItem("journeyStep", String(index));
	} catch (e) {}

	try {
		let stepsHistory = [];
		const stepLabels = ["Step 1", "Step 2", "Step 3", "Step 4"];
		const stored = localStorage.getItem("journeyStepsHistory");
		if (stored) {
			stepsHistory = JSON.parse(stored);
		}

		const stepNum = index + 1;
		if (!stepsHistory.some((s) => s.number === stepNum)) {
			stepsHistory.push({
				number: stepNum,
				label: stepLabels[index] || "Step " + stepNum,
			});
		}

		stepsHistory = stepsHistory.filter((s) => s.number <= stepNum);
		localStorage.setItem("journeyStepsHistory", JSON.stringify(stepsHistory));
	} catch (e) {}

	modal.scrollTo({
		top: 0,
		behavior: "auto",
	});
}

function goToRecommendationCenter() {
	window.location.href = "/pages/recommendation-center";
}

function resetSelections() {
	selectedType = null;
	selectedMachine = null;
	selectedElectrode = null;
	selectedAccessories = [];
}

function buildStepContent() {
	const electrodeTypeOptions = steps[currentStep].querySelector(
		".electrode-type-options"
	);
	const accessoriesOptions = steps[currentStep].querySelector(
		".accessories-options"
	);

	const accordionBtn = document.getElementById("accessoriesAccordionToggle");
	const accordionContent = document.querySelector(".accessories-options");

	if (electrodeTypeOptions) electrodeTypeOptions.innerHTML = "";
	if (accessoriesOptions) accessoriesOptions.innerHTML = "";

	if (currentStep === 1) {
		if (selectedType === "wireless") {
			const wirelessOrder = [
				{ name: "Combo 1 TENS & EMS Machine", code: "M100A" },
				{ name: "Combo 2 TENS & EMS Machine", code: "M101A" },
				{ name: "Combo 4 TENS & EMS Machine", code: "M103A" },
				{ name: "Painless TENS & EMS Machine", code: "KTR-501" },
				{
					name: "Med-Fit Wireless 2 Channel TENS & EMS Machine",
					code: "KTR-502",
				},
				{
					name: "Med-Fit Wireless 4 Channel TENS & EMS Machine",
					code: "KTR-504",
				},
				{ name: "Painless 23 - 15 Programmes", code: "Painless-23" },
				// { name: "Medi-Boost (1st Generation)", code: "KTR-402 (REFURB)" },
				// { name: "Medi-Boost (2nd Generation)", code: "KTR-402 (2nd GEN)" },
			];
			const hiddenCodes = [
				"KTR-402 (REFURB)",
				"KTR-402 (2nd GEN)"
			];

			const wirelessMachines = data.machines.filter((m) => {
				return (
					m.type === "wireless" &&
					!hiddenCodes.includes(m.code)
				);
			});
			const sorted = [...wirelessMachines].sort((a, b) => {
				const idxA = wirelessOrder.findIndex(
					(w) => w.code === a.code || w.name === a.machineName
				);
				const idxB = wirelessOrder.findIndex(
					(w) => w.code === b.code || w.name === b.machineName
				);
				if (idxA !== -1 && idxB !== -1) return idxA - idxB;
				if (idxA !== -1) return -1;
				if (idxB !== -1) return 1;
				return a.machineName.localeCompare(b.machineName);
			});
			const cards = document.querySelectorAll(".machine-card");
			cards.forEach((card) => {
				card.style.display = "none";
			});
			sorted.forEach((machine) => {
				const card = document.querySelector(
					`.machine-card[data-machine-type='wireless'][data-debug-code='${machine.code}']`
				);
				if (card) {
					card.style.display = "";
					card.parentNode.appendChild(card);
				}
			});
		} else {
			filterMachineCards();

			// if (selectedType === "wired") {
			// 	setTimeout(() => {
			// 		const mediBoostNames = {
			// 			"KTR-402 (REFURB)": "Medi-Boost (1st Generation)",
			// 			"KTR-402 (2nd GEN)": "Medi-Boost (2nd Generation)",
			// 		};
			// 		const wiredCards = document.querySelectorAll(
			// 			".machine-card[data-machine-type='wired']"
			// 		);
			// 		wiredCards.forEach((card) => {
			// 			const code = card.dataset.debugCode;
			// 			if (mediBoostNames[code]) {
			// 				const nameEl = card.querySelector(".custom-radio-option-name");
			// 				if (nameEl) nameEl.textContent = mediBoostNames[code];
			// 			}
			// 		});
			// 	}, 10);
			// }
		}

		let checkedValue = null;
		if (selectedMachine && selectedMachine.code && selectedMachine.type) {
			checkedValue = `${selectedMachine.code}||${selectedMachine.type}`;
		}

		const allRadios = steps[currentStep].querySelectorAll(
			'input[name="machine"]'
		);
		allRadios.forEach((r) => (r.checked = false));
		if (checkedValue) {
			let radio = steps[currentStep].querySelector(
				`input[name="machine"][value="${checkedValue}"]`
			);
			if (radio) radio.checked = true;
		}
	}

	if (currentStep === 2 && selectedMachine) {
		const { electrodes, accessories, treatmentArea } = selectedMachine;

		const electrodeKeys = Object.entries(electrodes)
			.filter(([k, v]) => Array.isArray(v) && v.length > 0)
			.map(([k]) => k);

		const accessoryKeys = Object.entries(accessories)
			.filter(([k, v]) => Array.isArray(v) && v.length > 0)
			.map(([k]) => k);

		if (electrodeKeys.length) {
			electrodeKeys.forEach((k) => {
				electrodeTypeOptions.innerHTML += `
						<div class="custom-radio">
							<input type="radio" id="${k}-electrode" name="electrode" value="${k}">
							<label for="${k}-electrode">
								<span class="radio-indicator"></span>
								${prettifyElectrodeKey(k)}
							</label>
						</div>
					`;
			});
		}

		if (accessoryKeys.length) {
			accessoryKeys.forEach((k) => {
				accessoriesOptions.innerHTML += `
					<label class="custom-checkbox">
						<input type="checkbox" name="accessory" value="${k}">
						<span class="checkbox-box" aria-hidden="true"></span>
						<span class="checkbox-label">${prettifyAccessoryKey(k)}</span>
					</label>
				`;
			});
		}

		setTimeout(() => {
			if (selectedElectrode) {
				const elInput = steps[2].querySelector(
					`input[name='electrode'][value='${selectedElectrode}']`
				);
				if (elInput) elInput.checked = true;
			}

			if (Array.isArray(selectedAccessories)) {
				selectedAccessories.forEach((acc) => {
					const accInput = steps[2].querySelector(
						`input[name='accessory'][value='${acc}']`
					);
					if (accInput) accInput.checked = true;
				});
			}

			if (Array.isArray(selectedTreatmentAreas)) {
				selectedTreatmentAreas.forEach((area) => {
					const areaInput = steps[2].querySelector(
						`input[name='treatmentArea'][value='${area}']`
					);
					if (areaInput) areaInput.checked = true;
				});
			}
		}, 0);

		steps[currentStep].addEventListener("change", (e) => {
			if (e.target.name === "electrode") {
				selectedElectrode = e.target.value;
				showTreatmentAreaOptions();
			}
		});
	}
}

function collectSelections() {
	if (currentStep === 0) {
		const val = steps[currentStep].querySelector(
			'input[name="type"]:checked'
		)?.value;
		if (!val) return false;

		if (selectedType !== val) {
			selectedType = val;
			selectedMachine = null;
			selectedElectrode = null;
			selectedAccessories = [];
			selectedTreatmentAreas = [];

			var machineRadios = document.querySelectorAll('input[name="machine"]');
			machineRadios.forEach(function (radio) {
				radio.checked = false;
			});
		} else {
			selectedType = val;
		}
		saveJourneyStepsValues();
		return true;
	}

	if (currentStep === 1) {
		const val = steps[currentStep].querySelector(
			'input[name="machine"]:checked'
		)?.value;

		if (!val) return false;

		let code = val,
			type = selectedType;
		if (val.includes("||")) {
			[code, type] = val.split("||");
		}

		if (
			!selectedMachine ||
			selectedMachine.code !== code ||
			selectedMachine.type !== type
		) {
			selectedMachine = data.machines.find(
				(m) => m.code === code && m.type === type
			);
			selectedElectrode = null;
			selectedAccessories = [];
			selectedTreatmentAreas = [];
		} else {
			selectedMachine = data.machines.find(
				(m) => m.code === code && m.type === type
			);
		}
		saveJourneyStepsValues();
		return true;
	}

	if (currentStep === 2) {
		selectedElectrode = steps[currentStep].querySelector(
			'input[name="electrode"]:checked'
		)?.value;

		selectedAccessories = Array.from(
			steps[currentStep].querySelectorAll('input[name="accessory"]:checked')
		).map((cb) => cb.value);

		selectedTreatmentAreas = Array.from(
			steps[currentStep].querySelectorAll('input[name="treatmentArea"]:checked')
		).map((cb) => cb.value);

		// Validation
		if (
			!selectedElectrode &&
			selectedAccessories.length === 0 &&
			selectedTreatmentAreas.length === 0
		) {
			showJourneyPopup(
				"Please select an option on this page before moving to our recommendations."
			);
			return false;
		}

		saveJourneyStepsValues();
		return true;
	}

	return true;
}

function showJourneyPopup(message) {
    // Remove existing popup if already exists
    const existing = document.getElementById("journey-popup");
    if (existing) existing.remove();

    const overlay = document.createElement("div");
    overlay.id = "journey-popup";

    overlay.style.cssText = `
        position:fixed;
        inset:0;
        background:rgba(0,0,0,.5);
        display:flex;
        justify-content:center;
        align-items:center;
        z-index:999999;
    `;

    const popup = document.createElement("div");

    popup.style.cssText = `
        width:90%;
        max-width:420px;
        background:#fff;
        border-radius:12px;
        padding:25px;
        text-align:center;
        box-shadow:0 20px 50px rgba(0,0,0,.2);
        font-family:inherit;
    `;

    popup.innerHTML = `
        <div style="font-size:45px;margin-bottom:10px;">⚠️</div>
        <h5 style="margin:0 0 12px;color:#143D8D;">
            Please Select an Option
        </h5>

        <p style="margin:0 0 20px;color:#555;line-height:1.6;">
            ${message}
        </p>

        <button
            style="
                background:#E31E24;
                color:#fff;
                border:none;
                padding:12px 30px;
                border-radius:8px;
                cursor:pointer;
                font-size:16px;
                font-weight:600;
            ">
            OK
        </button>
    `;

    popup.querySelector("button").onclick = () => overlay.remove();

    overlay.onclick = (e) => {
        if (e.target === overlay) overlay.remove();
    };

    overlay.appendChild(popup);
    document.body.appendChild(overlay);
}

function showTreatmentAreaOptions() {
	const treatmentAreaOptions = steps[currentStep].querySelector(
		".treatment-area-options"
	);

	if (!treatmentAreaOptions || !selectedMachine || !selectedElectrode) return;

	const { electrodes, treatmentArea } = selectedMachine;
	const selectedElectrodeItems = electrodes[selectedElectrode];

	if (!Array.isArray(selectedElectrodeItems)) return;

	treatmentAreaOptions.innerHTML = "";

	Object.entries(treatmentArea).forEach(([key, value]) => {
		if (!Array.isArray(value) || value.length === 0) return;

		const hasElectrode = value.some((v) => selectedElectrodeItems.includes(v));

		if (hasElectrode) {
			const label = document.createElement("label");
			label.className = "custom-checkbox";
			label.innerHTML = `
				   <input type="checkbox" name="treatmentArea" value="${key}">
				   <span class="checkbox-box" aria-hidden="true"></span>
				   <span class="checkbox-label">${prettifyTreatmentAreaKey(key)}</span>
			   `;
			treatmentAreaOptions.appendChild(label);
		}
	});

	treatmentAreaOptions.classList.remove("show");
	requestAnimationFrame(() => {
		treatmentAreaOptions.classList.add("show");
	});
}

function showPreview() {
	// NOTE: The "Checking your choices" preview step is no longer part of the
	// active flow (see attachStepNavigationListeners / attachStickyNavListeners),
	// but this function is left intact in case the preview markup/step is still
	// referenced elsewhere in the theme.
	const electrodeTypePreviewList = document.getElementById(
		"electrodeTypePreview"
	);
	const accessoriesPreviewList = document.getElementById("accessoriesPreview");
	const treatmentAreaPreviewList = document.getElementById(
		"treatmentAreasPreview"
	);

	if (!electrodeTypePreviewList || !accessoriesPreviewList || !treatmentAreaPreviewList) {
		return;
	}

	const electrodeBlock = electrodeTypePreviewList.closest(
		".preview-items-block"
	);
	const accessoriesBlock = accessoriesPreviewList.closest(
		".preview-items-block"
	);
	const treatmentAreaBlock = treatmentAreaPreviewList.closest(
		".preview-items-block"
	);

	electrodeTypePreviewList.innerHTML = "";
	accessoriesPreviewList.innerHTML = "";
	treatmentAreaPreviewList.innerHTML = "";

	if (!selectedMachine && data && Array.isArray(data.machines)) {
		const recData = (() => {
			try {
				return JSON.parse(localStorage.getItem("journeyStepsValues"));
			} catch {
				return null;
			}
		})();
		if (recData && recData.machine) {
			selectedMachine =
				data.machines.find((m) => m.code === recData.machine) || null;
			selectedElectrode = recData.electrode || null;
			selectedAccessories = Array.isArray(recData.accessories)
				? recData.accessories
				: [];
			selectedTreatmentAreas = Array.isArray(recData.treatmentAreas)
				? recData.treatmentAreas
				: [];
		}
	}

	const electrodes = selectedElectrode
		? Array.isArray(selectedElectrode)
			? selectedElectrode
			: [selectedElectrode]
		: [];

	if (electrodes.length) {
		electrodes.forEach((e) => {
			const li = document.createElement("li");
			li.textContent = prettifyElectrodeKey(e);
			electrodeTypePreviewList.appendChild(li);
		});
		electrodeBlock.style.display = "block";
	} else {
		electrodeBlock.style.display = "none";
	}

	if (selectedAccessories.length) {
		selectedAccessories.forEach((a) => {
			const li = document.createElement("li");
			li.textContent = prettifyAccessoryKey(a);
			accessoriesPreviewList.appendChild(li);
		});
		accessoriesBlock.style.display = "block";
	} else {
		accessoriesBlock.style.display = "none";
	}

	treatmentAreaBlock.style.display = "none";
}

// ---------------------------------------------------------------------------
// Builds the cart-attribute payload from current selections and redirects to
// the recommendations page. This is the same logic that used to live only in
// attachCloseButtonHandler's "Close" click — now reused so Step 2's
// Next/"Show recommendations" button can skip the old preview step entirely.
// ---------------------------------------------------------------------------
async function finalizeAndGoToRecommendations() {
	const upsell = selectedMachine?.upsell || "N/A";
	const upsellValue = Array.isArray(upsell)
		? upsell.map((u) => u.sku).join(",")
		: [];

	const state = {
		machineCode: selectedMachine?.code || "",
		electrodeTypes: Array.isArray(selectedElectrode)
			? selectedElectrode
			: selectedElectrode
			? [selectedElectrode]
			: [],
		treatmentAreas: Array.isArray(selectedTreatmentAreas)
			? selectedTreatmentAreas
			: selectedTreatmentAreas
			? [selectedTreatmentAreas]
			: [],
		accessories: Array.isArray(selectedAccessories)
			? selectedAccessories
			: selectedAccessories
			? [selectedAccessories]
			: [],
		upsell: upsellValue,
		promoCode: selectedMachine?.promoCode || "",
	};

	await saveRecommendationState(state);
}

function attachStepNavigationListeners() {
	steps.forEach((stepDiv, index) => {
		const nextBtn = stepDiv.querySelector(".next-step");
		const backBtn = stepDiv.querySelector(".back-step");

		if (nextBtn) {
			nextBtn.addEventListener("click", async () => {
				if (!collectSelections()) {
					return;
				}

				// Step 2 (electrode/accessories/treatment area) is now the LAST
				// step in the flow. Instead of advancing to the old "Checking
				// your choices" preview (step 3), go straight to the
				// recommendations page.
				if (currentStep === 2) {
					await finalizeAndGoToRecommendations();
					return;
				}

				currentStep++;
				buildStepContent();
				showStep(currentStep);
				saveJourneyStepsValues();
			});
		}

		if (backBtn) {
			backBtn.addEventListener("click", () => {
				if (currentStep > 0) {
					currentStep--;
					showStep(currentStep);
					saveJourneyStepsValues();
				}
			});
		}
	});
}

function openModal(presetType = null, startAtStep = 0, clearStorage = false) {

	if (!modal) {
		initializeElements();
	}

	if (!modal) {
		console.error("Modal element not found");
		return;
	}

	loadData();

	if (clearStorage) {
		try {
			localStorage.removeItem("journeyStepsValues");
			console.log("localStorage cleared on initial URL open");
		} catch (e) {}
	}

	let recData = null;
	try {
		const stored = localStorage.getItem("journeyStepsValues");
		if (stored) {
			recData = JSON.parse(stored);
		}
	} catch (e) {
		recData = null;
	}

	resetSelections();

	if (recData) {
		selectedType = recData.type || null;
		if (data && Array.isArray(data.machines)) {
			selectedMachine =
				data.machines.find(
					(m) => m.code === recData.machine && m.type === recData.type
				) || null;
		}
		selectedElectrode = recData.electrode || null;
		selectedAccessories = Array.isArray(recData.accessories)
			? recData.accessories
			: [];
		selectedTreatmentAreas = Array.isArray(recData.treatmentAreas)
			? recData.treatmentAreas
			: [];

		if (steps[0]) {
			const typeInput = steps[0].querySelector(
				`input[name="type"][value="${selectedType}"]`
			);
			if (typeInput) typeInput.checked = true;
		}

		if (steps[1]) {
			if (selectedType) {
				const cards = document.querySelectorAll(".machine-card");
				cards.forEach((card) => {
					card.style.display =
						card.dataset.machineType === selectedType ? "" : "none";
				});
			}

			if (selectedMachine && selectedMachine.code && selectedMachine.type) {
				const checkedValue = `${selectedMachine.code}||${selectedMachine.type}`;
				const machineInput = steps[1].querySelector(
					`input[name="machine"][value="${checkedValue}"]`
				);
				if (machineInput) machineInput.checked = true;
			}
		}

		if (steps[2] && selectedMachine) {
			if (selectedElectrode) {
				const elInput = steps[2].querySelector(
					`input[name='electrode'][value='${selectedElectrode}']`
				);
				if (elInput) elInput.checked = true;
			}

			if (Array.isArray(selectedAccessories)) {
				selectedAccessories.forEach((acc) => {
					const accInput = steps[2].querySelector(
						`input[name='accessory'][value='${acc}']`
					);
					if (accInput) accInput.checked = true;
				});
			}

			if (Array.isArray(selectedTreatmentAreas)) {
				selectedTreatmentAreas.forEach((area) => {
					const areaInput = steps[2].querySelector(
						`input[name='treatmentArea'][value='${area}']`
					);
					if (areaInput) areaInput.checked = true;
				});
			}
		}
	}

	if (presetType) {
		selectedType = presetType;
	}

	if (!selectedType && steps[0]) {
		const wiredInput = steps[0].querySelector(
			'input[name="type"][value="wireless"]'
		);
		if (wiredInput) {
			wiredInput.checked = true;
			selectedType = "wireless";
		}
	}

	if (
		typeof startAtStep === "number" &&
		startAtStep >= 0 &&
		startAtStep < steps.length
	) {
		currentStep = startAtStep;
	} else {
		currentStep = 0;
	}

	if (currentStep === 0 && steps[0] && !selectedType) {
		const checkedTypeInput = steps[0].querySelector(
			'input[name="type"]:checked'
		);
		if (checkedTypeInput) {
			selectedType = checkedTypeInput.value;
		}
	}

	if (currentStep === 1 && selectedType) {
		filterMachineCards();
	}

	if (currentStep !== 0) {
		buildStepContent();
	}
	showStep(currentStep);

	modal.style.display = "flex";
	document.body.style.overflow = "hidden";
	document.documentElement.style.overflow = "hidden";
}

function initEventListeners() {
	initializeElements();

	attachStepNavigationListeners();
	attachStickyNavListeners();

	attachCloseButtonHandler();

	if (openBtn) {
		openBtn.addEventListener("click", async () => {
			await openModal();
		});
	}
}

function attachStickyNavListeners() {
	if (stickyBackBtn) {
		stickyBackBtn.addEventListener("click", () => {
			if (currentStep > 0) {
				currentStep--;
				showStep(currentStep);
				saveJourneyStepsValues();
			}
		});
	}

	if (stickyNextBtn) {
		stickyNextBtn.addEventListener("click", async () => {
			// Collect selections before moving forward
			if (!collectSelections()) {
				return;
			}

			// Step 2 (electrode/accessories/treatment area) is now the LAST
			// step in the flow. Skip the old "Checking your choices" preview
			// (step 3) and go straight to the recommendations page.
			if (currentStep === 2) {
				await finalizeAndGoToRecommendations();
				return;
			}

			currentStep++;
			buildStepContent();
			showStep(currentStep);
			saveJourneyStepsValues();
		});
	}
}

function autoOpenJourneyModal() {
	const path = (
		(window.location && window.location.pathname) ||
		""
	).toLowerCase();
	if (!path.startsWith(window.localeRoot+"/journey") && !path.startsWith(window.localeRoot+"/pages/journey"))
		return;

	const open = () => {
		if (typeof openModal === "function") {
			openModal();
			const loader = document.getElementById("journeyLoader");
			if (loader) loader.style.display = "none";
		}
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", () => open());
	} else {
		open();
	}
}

// Run initialization
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", () => {
		initEventListeners();
	});
} else {
	initEventListeners();
}

window.openModal = openModal;

window.reopenFinderModal = function (deviceType) {
	openModal(deviceType, 1);
};

window.reopenFinderModalWithStep = function (stepIndex) {
	openModal(null, stepIndex);
};

// ---------------------------------------------------------------------------
// "Go Back One Step" — used on the recommendations page so a user who spots a
// wrong selection can jump straight back into the finder at the electrode/
// accessories/treatment-area step (index 2). openModal() will automatically
// restore their previous type/machine/electrode/accessory/treatment-area
// choices from localStorage ("journeyStepsValues"), so nothing is lost.
// ---------------------------------------------------------------------------
window.goBackOneStep = function () {
	window.reopenFinderModalWithStep(2);
};

async function saveRecommendationState(state) {
	try {
		const cartRes = await fetch("/cart.js");
		const currentCart = await cartRes.json();
		const currentMachineCode = currentCart.attributes?.machine_code;

		if (currentMachineCode && currentMachineCode !== state.machineCode) {
			await fetch("/cart/clear.js", { method: "POST" });

			await fetch("/cart/update.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ attributes: { vat_form_completed: null } }),
			});

			localStorage.removeItem("VatReliefDeclaration");
		}

		const formData = {
			attributes: {
				machine_code: state.machineCode,
				electrode_types: state.electrodeTypes.join(","),
				treatment_areas: state.treatmentAreas.join(","),
				accessories: state.accessories.join(","),
				upsell: state.upsell,
				promoCode: state.promoCode,
			},
		};

		const res = await fetch("/cart/update.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(formData),
		});
		const updatedCart = await res.json();

		// Store data globally for Change button
		window.recommendationCenterData = {
			machineCode: state.machineCode,
			machineType: selectedType,
			electrodeTypes: state.electrodeTypes,
			treatmentAreas: state.treatmentAreas,
			accessories: state.accessories,
			upsell: state.upsell,
		};

		localStorage.setItem(
			"recommendationCenterData",
			JSON.stringify(window.recommendationCenterData)
		);
		window.location.href = "/pages/recommendation-center";
	} catch (err) {
		console.error("Failed to save cart attributes:", err);
	}
}

async function updateRecommendationSection() {
	window.location.href = "/pages/recommendation-center";
}

function attachChangeButtonHandler() {
	setTimeout(() => {
		const changeButton = document.querySelector(
			".custom-product-option-button"
		);

		if (changeButton) {
			// Force styles to ensure it's clickable
			changeButton.style.cursor = "pointer";
			changeButton.style.pointerEvents = "auto";

			// Remove any existing listeners by cloning
			const newButton = changeButton.cloneNode(true);
			changeButton.parentNode.replaceChild(newButton, changeButton);

			newButton.addEventListener("click", function (e) {
				e.preventDefault();
				e.stopPropagation();

				const deviceType = window.recommendationCenterData?.machineType;

				if (deviceType) {
					// Hide recommendation section
					const recContainer = document.querySelector(
						"#recommendationCenterContainer"
					);
					if (recContainer) {
						recContainer.style.display = "none";
					}

					// Show modal content
					const modalContent = document.querySelector("#modalContent");
					if (modalContent) {
						modalContent.style.display = "block";
					}

					// Reset and reopen at device selection step
					resetSelections();
					selectedType = deviceType;
					currentStep = 1;
					filterMachineCards();
					buildStepContent();
					showStep(currentStep);

					// Reinitialize the close button handler
					attachCloseButtonHandler();
				} else {
					console.error("No device type found");
				}
			});
		} else {
			console.error("Change button not found");
		}
	}, 100);
}

function attachCloseButtonHandler() {
	const closeBtn = document.getElementById("closeModal");
	if (closeBtn) {
		// Clone to remove old listeners
		const newCloseBtn = closeBtn.cloneNode(true);
		closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);

		newCloseBtn.addEventListener("click", async function (e) {
			e.preventDefault();
			await finalizeAndGoToRecommendations();
		});
	} else {
		console.error("Close button not found");
	}
}